<div class="table-responsive gung-responsive">
  <table class="table table-borderless table-striped table-hover">
    <thead>
      <tr>
        <th scope="col" translate>ORDER_ID</th>
        <th scope="col" translate>ORDER_STATUS</th>
        <th scope="col" translate>DELIVERY_ADDRESS</th>
        <th scope="col" translate>SALESPERSON</th>
        <th scope="col" translate>DELIVERY_DATE</th>
        <th scope="col" translate>TOTAL</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let order of data" (click)="goToDetail(order)" [ngClass]="classSelector(order.extra.oh.ordstat)">
        <td [attr.data-label]="'ORDER_ID' | translate">{{ order.id }}</td>
        <td [attr.data-label]="'ORDER_STATUS' | translate" translate>OH_ORDSTAT_{{ order.extra.oh.ordstat }}</td>
        <td [attr.data-label]="'DELIVERY_ADDRESS' | translate">{{ order.extra.oh.ordlevadr1 || '-' }}</td>
        <td [attr.data-label]="'SALESPERSON' | translate">{{ getSalespersonMetadata(order.extra.oh.saljare) }}</td>
        <td [attr.data-label]="'DELIVERY_DATE' | translate">
          {{ order.extra.oh.ordberlevdat | date: dateUtilService.dateFormat }}
        </td>
        <td [attr.data-label]="'TOTAL' | translate">
          <lib-price [price]="order.extra.oh.ohvbordsum" [currency]="order.extra.oh.valkod"></lib-price>
        </td>
        <td>
          <div>
            <div
              ngbDropdown
              class="d-inline-block mr-2 dropdown"
              *ngIf="order.extra?.deliveries_logtrade && order.extra.deliveries_logtrade.length > 0"
            >
              <button
                type="button"
                class="dropdown-toggle btn btn-outline-primary"
                id="dropdownTrack"
                ngbDropdownToggle
                (click)="$event.stopPropagation()"
                translate
              >
                TRACK_ORDER
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownTrack">
                <button
                  ngbDropdownItem
                  *ngFor="let item of order.extra.deliveries_logtrade; let i = index"
                  (click)="$event.stopPropagation(); goToPage(item.shipmentNo)"
                >
                  <span translate>TRACKING</span>&nbsp;{{ i + 1 }}
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
